import React, { Component } from "react";
import "../public/assets/vendor/fonts/flag-icons.css";
import "../public/assets/vendor/fonts/fontawesome.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Autocomplete, InputAdornment } from "@mui/material";
import TextField from "@mui/material/TextField";
import "react-datepicker/dist/react-datepicker.css";
import { ValidatorForm } from "react-material-ui-form-validator";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import { ThemeProvider } from "@material-ui/styles";
import { createTheme } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import subDays from "date-fns/subDays";
import DateFnsUtils from "@date-io/date-fns";
import "react-tabs/style/react-tabs.css";
import FetchServerData from "../../../provider/FetchServerData";
import {
  CheckDpTextExistingEmail_Url,
  DPTextPostVerify_Url,
  DPTextRegistration_Url,
  GetCountryList_Url,
} from "../../../provider/ServiceUrl";
import Utils from "../../../provider/Utils";
import { withRouter } from "../../../withRouter";
import dpTextLogo from "../../../assets/img/dptextLogo.png";
import InfoTooltip from "../infoTooltip/InfoTooltip";
import "../public/assets/css/demo.css";
import "../public/assets/vendor/css/rtl/theme-default.css";
import "../public/assets/vendor/libs/bootstrap-select/bootstrap-select.css";
import "../public/assets/vendor/libs/bs-stepper/bs-stepper.css";
import "../public/assets/vendor/libs/formvalidation/dist/css/formValidation.min.css";
import "../public/assets/vendor/libs/perfect-scrollbar/perfect-scrollbar.css";
import "../public/assets/vendor/libs/select2/select2.css";
import "../public/assets/vendor/libs/typeahead-js/typeahead.css";
import "./Registration.css";
import { SUBSCRIPTION_TYPES } from "../../../provider/Enums";
import ChoosePlanIcon from "../../../assets/img/planning.png"
import UserIcon from "../../../assets/img/user.png"
import { BorderRight } from "@mui/icons-material";

const materialTheme = createTheme({
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: "#008181",
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        backgroundColor: "white",
        color: "#005476",
      },
    },
  },
});
class DPTextRegistration extends Component {
  countryListArray = [];
  stateListArray = [];
  paymentTermList = [
    { type: "Pay Monthly", id: 1 },
    { type: "Pay Yearly", id: 2 },
  ];
  constructor(props) {
    super(props);
    this.state = {
      userName: "",
      email: "",
      firstName: "",
      lastName: "",
      jobTitle: "",
      phone: "",
      phoneNumber: "",
      countryCode: "+1",
      officeCountryCode: "+1",
      officePhone: "",
      officePhoneNumber: "",
      error: {
        one: true,
        two: true,
        three: true,
        four: true,
        five: true,
      },
      errorMessageText: "",
      cwUrlErrorMessage: "",
      privacyErrorMessageText: "",
      einErrorMessageText: "",
      confirmPasswordHelperText: "",
      activeCompanyDetailsStep: false,
      activeGivBeePlanStep: true,
      planList: [],
      tabPlanList: [],
      showPassword: false,
      selectedTab: 0,
      selectedPlanId: "",
      selectedPlan: null,
      line: "",
      state: null,
      city: "",
      zipcode: "",
      eInNumber: "",
      timeZone: null,
      zipCodeErrorMessageText: "",
      selectedPlanListItem: {},
      companyWebsite: "",
      smsTAndCUrl: "",
      smsPrivacyPolicyUrl: "",
      donerPerfectApiKey: "",
      donerPerfectCliendId: "",
      dpSalesPerson: "",
      dpSalesPersonEmail: "",
      paymentTerm: null,
      startDate: null,
      endDate: null,
      errorMassage: false,
      endDateErrorMassage: false,
      error: false,
    };
    this.getStaticData();
  }

  componentDidMount() {
    // make API call
    const postObject = {};
    FetchServerData.callPostService("/planms/getActiveForDPText", postObject)
      .then((response) => {
        let output = response;
        if (output.status === "SUCCESS") {
          let planList = output.data.planList;
          let tabPlanList = planList.reduce((unique, o) => {
            if (
              !unique.some((obj) => obj.planType?.type === o.planType?.type)
            ) {
              unique.push(o);
            }
            return unique;
          }, []);
          this.setState({
            render: true,
            tabPlanList: tabPlanList,
            planList: planList,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  getStaticData() {
    // make API call
    const postObject = {
      header: {},
    };
    FetchServerData.callPostService("/countryms/getList", postObject)
      .then((response) => {
        let output = response;
        if (output.status === "SUCCESS") {
          let countryList = output.data.countryList;
          this.countryListArray = countryList;
          let defaultCountry =
            countryList[
            countryList.findIndex(
              (i) => i.isocode.toLowerCase() === "USA".toLowerCase()
            )
            ];
          this.setState({
            country: defaultCountry,
          });
          this.handleCountryChange(defaultCountry);
        } else {
        }
      })
      .catch((error) => { });
  }

  setKey(tab) {
    this.setState({
      selectedTab: tab,
    });
  }

  handleUserNameChange(e) {
    this.setState({ userName: e.target.value });
  }
  handleFnameChange(e) {
    this.setState({ firstName: e.target.value });
  }
  handleLnameChange(e) {
    this.setState({ lastName: e.target.value });
  }
  handleEmailChange(e) {
    this.setState({ email: e.target.value });
  }
  handleJobTitleChange(e) {
    this.setState({ jobTitle: e.target.value });
  }

  handlePhoneChange(e) {
    let val = e.target.value;
    if (val.length <= 12) {
      let value = Utils.phoneNumberFormate(val);
      this.setState({
        phone: value,
        phoneNumber: e.target.value.replace(/-/g, ""),
      });
    }
  }

  handleOfficePhoneChange(e) {
    let val = e.target.value;
    if (val.length <= 12) {
      let value = Utils.phoneNumberFormate(val);
      this.setState({
        officePhone: value,
        officePhoneNumber: e.target.value.replace(/-/g, ""),
      });
    }
  }

  handleCountryCodeChange(phone, country, e, formattedValue) {
    this.setState({
      countryCode: formattedValue,
    });
  }
  handleOfficeCountryChange(phone, country, e, formattedValue) {
    this.setState({
      officeCountryCode: formattedValue,
    });
  }

  handlePreviousPlanDetailsPage(e) {
    e.preventDefault();

    this.setState({
      activeCompanyDetailsStep: false,
      activeGivBeePlanStep: true,
    });
  }

  handleOnClickSelectedPlan(selectedPlan) {
    console.log(selectedPlan)
    this.setState({
      selectedPlanId: selectedPlan.id,
      activeCompanyDetailsStep: true,
      activeGivBeePlanStep: false,
      selectedPlan: selectedPlan,
    });
    window.scrollTo(0, 0);
  }

  handleEinChange(e) {
    let val = e.target.value;
    let value = this.einNumberAutoFormat(val);
    let res = value.substring(0, 11);
    if (res.length < 11) {
      this.setState({
        eIn: value,
        einErrorMessageText: "",
        eInNumber: e.target.value,
      });
    }
  }

  einNumberAutoFormat(einNumber) {
    const number = einNumber.replace(/\D/g, "");
    const isCanada = Utils.equalsIgnoreCase(
      this.state.country?.name,
      "Canada"
    );

    if (isCanada) {
      const trimmed = number.substring(0, 9);
      if (trimmed.length > 5) {
        return trimmed.replace(/(\d{5})(\d{0,4})/, "$1 $2").trim();
      }

      return trimmed;
    } else {
      const trimmed = number.substring(0, 9);
      if (trimmed.length > 2) {
        return trimmed.replace(/(\d{2})(\d{0,7})/, "$1-$2");
      }

      return trimmed;
    }
  }

  handleBusinessNameChange(e) {
    this.setState({ businessName: e.target.value });
  }

  handleSmsTAndCUrlChange(e) {
    let pattern = Utils.urlPattern(e.target.value);
    if (pattern === true) {
      this.setState({ smsTAndCUrl: e.target.value, errorMessageText: "" });
    } else {
      this.setState({
        smsTAndCUrl: e.target.value,
        errorMessageText: "Please enter valid URL",
      });
    }
  }
  handleSmsPrivacyPolicyUrlChange(e) {
    let pattern = Utils.urlPattern(e.target.value);
    if (pattern === true) {
      this.setState({
        smsPrivacyPolicyUrl: e.target.value,
        privacyErrorMessageText: "",
      });
    } else {
      this.setState({
        smsPrivacyPolicyUrl: e.target.value,
        privacyErrorMessageText: "Please enter valid URL",
      });
    }
  }

  handleCompanyWebsiteChange(e) {
    const val = e.target.value;
    let cwUrlErrorMessage = "";
    this.setState({
      companyWebsite: val,
      cwUrlErrorMessage,
    });
  }

  handleStateChange(selectedState) {
    this.state.state = selectedState;
    this.setState({ state: selectedState });
    if (undefined !== this.onChange && null !== this.onChange) {
      this.onChange(this.state);
    }
  }
  handleTimeZoneChange(selectedTimezone) {
    this.state.timeZone = selectedTimezone;
    this.setState({ timeZone: selectedTimezone });
    if (undefined !== this.onChange && null !== this.onChange) {
      this.onChange(this.state);
    }
  }
  handleLine1Change(e) {
    let val = e.target.value;
    let res = val.substring(0, 128);
    if (res.length < 128) {
      this.setState({ line: res });
    } else {
      Utils.maxFieldLength(128);
    }
  }

  handleLine2Change(e) {
    this.setState({ line2: e.target.value });
  }

  handleCityChange(e) {
    let val = Utils.toCamelCase(e.target.value);
    let res = val.substring(0, 128);
    if (res.length < 128) {
      this.setState({ city: res });
    } else {
      Utils.maxFieldLength(128);
    }
  }

  handlePinCodeChange(e) {
    let val = e.target.value;
    if (Utils.equalsIgnoreCase(this.state.country?.name, "Canada")) {
      let res = val.substring(0, 7);
      if (res.length < 7) {
        this.setState({ zipcode: res, zipCodeErrorMessageText: "" });
      }
    } else {
      let res = val.substring(0, 6);
      if (res.length < 6) {
        this.setState({ zipcode: res, zipCodeErrorMessageText: "" });
      }
    }
  }

  handleCountryChange(selectedCountry) {
    if (null === selectedCountry || selectedCountry === "") {
      this.stateListArray = [];
      this.setState({
        stateClear: !this.state.stateClear,
      });
      return;
    }
    this.state.country = selectedCountry;
    if (undefined !== this.onChange && null !== this.onChange) {
      this.onChange(this.state);
    }

    this.setState({
      country: selectedCountry,
      state: null,
    });

    const postObject = {
      header: {},
      country: { id: selectedCountry.id },
    };
    FetchServerData.callPostService(GetCountryList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let stateTimezoneList = output.data.country;
          this.stateListArray = stateTimezoneList.states;
          this.timeZoneListArray = stateTimezoneList.timezones;
          this.setState({
            render: true,
          });
        } else {
        }
      }
    );
  }

  handleDonerPerfectApiKeyChange(e) {
    this.setState({
      donerPerfectApiKey: e.target.value,
    });
  }
  handleDonerPerfectCliendIDChange(e) {
    this.setState({
      donerPerfectCliendId: e.target.value,
    });
  }
  handleDPSalesPersonChange(e) {
    this.setState({
      dpSalesPerson: e.target.value,
    });
  }
  handleDPSalesPersonEmailChange(e) {
    this.setState({
      dpSalesPersonEmail: e.target.value,
    });
  }
  handlePaymentTermChange(selected) {
    this.setState({
      paymentTerm: selected,
    });
  }

  handleStartDateChange(date) {
    let fromDate = Date.parse(date);
    let toDate = Date.parse(this.state.endDate);
    if (this.state.endDate === null && date === null) {
      this.setState({
        startDate: date,
        error: false,
        errorMassage: false,
      });
    } else if (date === null) {
      this.setState({
        startDate: date,
        error: false,
        errorMassage: true,
      });
    } else if (fromDate > toDate) {
      this.setState({
        startDate: date,
        error: true,
        errorMassage: false,
      });
    } else {
      this.setState({
        startDate: date,
        error: false,
        errorMassage: false,
      });
    }
  }

  handleEndDateChange(date) {
    let fromDate = Date.parse(this.state.startDate);
    let toDate = Date.parse(date);

    if (this.state.startDate === null && date === null) {
      this.setState({
        endDate: date,
        error: false,
        errorMassage: false,
        endDateErrorMassage: true,
      });
    } else if (this.state.startDate === null) {
      this.setState({
        endDate: date,
        error: false,
        errorMassage: true,
        endDateErrorMassage: false,
      });
    } else if (fromDate > toDate) {
      this.setState({
        endDate: date,
        error: true,
        errorMassage: false,
        endDateErrorMassage: false,
      });
    } else {
      this.setState({
        endDate: date,
        error: false,
        errorMassage: false,
        endDateErrorMassage: false,
      });
    }
  }

  createAccountInBackend() {
    const postObject = {
      registration: {
        email: this.state.email,
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        jobtitle: this.state.jobTitle,
        phoneCountrycode: this.state.countryCode,
        phone: this.state.phoneNumber,
        orgPlan: this.state.selectedPlanId,
        orgPhone: this.state.officePhoneNumber,
        orgPhoneCountrycode: this.state.officeCountryCode,
        orgEin: this.state.eInNumber,
        orgName: this.state.businessName,
        orgWebsite: this.state.companyWebsite,
        orgTandc: this.state.smsTAndCUrl,
        orgPrivacyPolicy: this.state.smsPrivacyPolicyUrl,
        orgAddressCity: this.state.city,
        orgAddressLine: this.state.line,
        orgAddressState: this.state.state.id,
        orgTimezone: this.state.timeZone.id,
        orgAddressZipcode: this.state.zipcode,
        crmDptextApikey: this.state.donerPerfectApiKey,
        crmDptextClientid: this.state.donerPerfectCliendId,
        paymentTerms: this.state.paymentTerm?.type,
        salesPersonName: this.state.dpSalesPerson,
        salesPersonEmail: this.state.dpSalesPersonEmail,
        onetimeStartDate: this.state.startDate,
        onetimeEndDate: this.state.endDate,
      },
    };
    FetchServerData.callPostService(DPTextRegistration_Url, postObject)
      .then((response) => {
        let output = response;
        let verifyData = output.data.registration;
        if (output.status === "SUCCESS") {
          const postObject = {
            header: {},
            registration: verifyData,
          };
          FetchServerData.callPostService(
            DPTextPostVerify_Url,
            postObject
          ).then((output) => {
            if (output.status === "SUCCESS") {
              this.props.navigate("/dptextSignin", {
                state: {
                  email: this.state.email,
                  pageId: "DPTextRegistration",
                },
              });
            }
          });
        } else {
        }
      })
      .catch((error) => { });
  }
  searchExistingEmail() {
    const postObject = {
      email: this.state.email,
    };
    if (!Utils.isNullOrEmpty(this.state.email)) {
      FetchServerData.callPostService(CheckDpTextExistingEmail_Url, postObject).then(
        (output) => {
          if (output.status === "SUCCESS") {
          } else {
            if (output.errorCode === "REGISTRATION_EXISTS") {
              this.setState({
                email: "",
              });
            }
          }
        }
      );
    }
  }


  handleStepClick = (stepKey) => {
    this.setState({
      activeGivBeePlanStep: stepKey === "plan",
      activeCompanyDetailsStep: stepKey === "company",
    });
  };

  render() {
    this.addressRef = React.createRef();
    this.billingAddressRef = React.createRef();
    const colors = [
      "#9bdef9",
      "#ff9999",
      // "#d4dfd1",
      "#e4b982",
      "#67e0e9",
      "#e8b1c4",
      // "#67e0e9",
      // "#e8b1c4",
      "#7ab9de",
      "#84bfcf",
      "#f4eade",
      "#ffb6b9",
    ];
    const planTitleColors = [
      "#26b9f2",
      "#ff6666",
      // "#729669",
      "#d18a2e",
      "#20d2df",
      "#c43b6b",
      // "#20d2df",
      // "#c43b6b",
      "#3394cc",
      "#479fb8",
      "#bf8640",
      "#ff0008",
    ];

    // let monthlyPlanListArr = [];
    // let yearlyPlanListArr = [];
    // for (
    //   let i = 0;
    //   i <
    //   this.state.planList.sort((a, b) => a.displaysequence - b.displaysequence)
    //     ?.length;
    //   i++
    // ) {
    //   if (
    //     Utils.equalsIgnoreCase(
    //       this.state.planList[i].planType?.type,
    //       SUBSCRIPTION_TYPES.payMonthly
    //     )
    //   ) {
    //     monthlyPlanListArr.push(this.state.planList[i]);
    //   } else if (
    //     Utils.equalsIgnoreCase(
    //       this.state.planList[i].planType?.type,
    //       SUBSCRIPTION_TYPES.payYearly
    //     )
    //   ) {
    //     yearlyPlanListArr.push(this.state.planList[i]);
    //   }
    // }

    const planTypeMap = {};

    this.state.planList.forEach((plan) => {
      const type = plan.planType?.type;
      if (!type) return;

      if (!planTypeMap[type]) {
        planTypeMap[type] = {
          description: plan.planType.description,
          plans: []
        };
      }

      planTypeMap[type].plans.push(plan);
    });

    const PLAN_TAB_SEQUENCE = [
      SUBSCRIPTION_TYPES.payYearly,
      SUBSCRIPTION_TYPES.payMonthly,
      SUBSCRIPTION_TYPES.payOnetime
    ];

    const orderedTabTypes = PLAN_TAB_SEQUENCE.filter(
      (type) => planTypeMap[type]
    );

    orderedTabTypes.forEach((type) => {
      planTypeMap[type].plans.sort(
        (a, b) => (a.displaysequence ?? 0) - (b.displaysequence ?? 0)
      );
    });

    const enableCountryCode = process.env.REACT_APP_ENABLE_COUNTRYCODE === "true";

    return (
      <>
        <header
          id="dptextheader"
          className="fixed-top d-flex align-items-center"
        >
          <div className="container d-flex align-items-center justify-content-between">
            <div className="logo">
              <img
                src={dpTextLogo}
                alt=""
                style={{ width: "auto", height: "60px" }}
              />
            </div>
            <nav id="navbar" className="navbar">
              <ul>
                <li>
                  <a
                    className="nav-link scrollto"
                    href="/dptextSignin"
                    style={{ color: "#53a5ff" }}
                  >
                    SIGN IN
                  </a>
                </li>
                {/* <li className="active">
                  <a
                    className="nav-link scrollto"
                    href="/dptextSignup"
                    style={{ color: "#53a5ff" }}
                  >
                    Sign Up
                  </a>
                </li> */}
              </ul>
              <i className="bi bi-list mobile-nav-toggle" />
            </nav>
          </div>
        </header>
        <div className="container">
          <div className="main">
            <div className="main_inner">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="heading pt-4 ps-4 mb-0">Sign Up</h3>
                </div>
              </div>
              <hr></hr>
              <div className="authentication-inner row m-0">
                <div className="col-lg-12 align-items-center authentication-bg">
                  <div className="px-1000">
                    <div
                      id="multiStepsValidation"
                      className="bs-stepper shadow-none"
                    >
                      <div className="bs-stepper-header border-bottom-0">
                        <div
                          // className="step"
                          data-target="#givBeeSolutionsValidation"
                          className={
                            this.state.activeGivBeePlanStep === true
                              ? "step active"
                              : "step"
                          }
                        >
                          <button type="button" className="step-trigger" onClick={() => this.handleStepClick("plan")}>
                            <span className="bs-stepper-circle">
                              {/* <i className="bx bx-home-alt" /> */}
                              <img src={ChoosePlanIcon} alt="Choose a plan" style={{ height: "25px" }} />
                            </span>
                            <span className="bs-stepper-label mt-1">
                              <span className="bs-stepper-title">
                                Choose Plan
                              </span>
                            </span>
                          </button>
                        </div>
                        <div className="line">
                          <i className="bx bx-chevron-right" />
                        </div>
                        <div
                          data-target="#companyDetailsValidation"
                          className={
                            this.state.activeCompanyDetailsStep === true
                              ? "step active"
                              : "step"
                          }
                        >
                          <button type="button" className="step-trigger" onClick={() => this.handleStepClick("company")}>
                            <span className="bs-stepper-circle">
                              {/* <i className="bx bx-user" /> */}
                              <img src={UserIcon} alt="Choose a plan" style={{ height: "25px" }} />
                            </span>
                            <span className="bs-stepper-label mt-1">
                              <span className="bs-stepper-title">
                                {" "}
                                Account Info
                              </span>
                            </span>
                          </button>
                        </div>
                      </div>
                      <div
                        className="bs-stepper-content"
                        style={{ padding: "0.8rem 0.5rem 1.5rem 0.5rem" }}
                      >
                        {this.state.activeGivBeePlanStep === true && (
                          <div
                            id="givBeeSolutionsValidation"
                            className={
                              this.state.activeGivBeePlanStep === true
                                ? "content active dstepper-block fv-plugins-bootstrap5 fv-plugins-framework"
                                : '"content'
                            }
                          >
                            <div
                              className="card "
                              id="dpTextPlanDetailCard"
                              style={{ background: "#fff", width: "100%" }}
                            >
                              <div className="row mt-1 mb-4">
                                {this.state.planList?.length > 0 && (
                                  <div className="col-md-12">
                                    <div
                                      className="content-header"
                                      style={{
                                        textAlign: "left",
                                        padding: "0.6em 0em 0em 0em",
                                      }}
                                    >
                                      <h4 className="m-0"> Plan Options:</h4>
                                    </div>
                                    <div
                                      className="row mt-2"
                                    // style={{ margin: "auto" }}
                                    >
                                      <Tabs
                                        defaultIndex={this.state.selectedTab}
                                        onSelect={(k) => this.setKey(k)}
                                      >
                                        <TabList
                                          style={{
                                            listStyle: "none",
                                            margin: "0",
                                          }}
                                          className="text-start d-flex justify-content-start settingTabList ps-0"
                                        >
                                          {orderedTabTypes.map((type, index) => (
                                            <Tab className="tabSubscription hoverTab" key={type}>
                                              {planTypeMap[type].description}
                                            </Tab>
                                          ))}
                                        </TabList>
                                        {orderedTabTypes.map((type) => (
                                          <TabPanel key={type}>
                                            <div className="row d-flex align-item-stretch">
                                              {planTypeMap[type].plans.map((plan, index) => (
                                                <div className="col-md-3 mt-3" key={plan.id}>
                                                  <div
                                                    className="box"
                                                    data-aos="zoom-in"
                                                    data-aos-delay={
                                                      100
                                                    }
                                                    style={{
                                                      padding: "0em",
                                                      position:
                                                        "relative",
                                                      height: "100%",
                                                    }}
                                                    id="regPlanBox"
                                                  >
                                                    <div
                                                      className="regplan-inner plan_card plan_card_bottom d-flex flex-column"
                                                      style={{
                                                        height:
                                                          "100%",
                                                      }}
                                                    >
                                                      <div
                                                        class="entry-title plan_card"
                                                        style={{
                                                          background:
                                                            plan.colorSecondary !==
                                                              null
                                                              ? plan.colorSecondary
                                                              : colors[
                                                              index %
                                                              colors.length
                                                              ],
                                                        }}
                                                      >
                                                        <h3
                                                          class="plan_card"
                                                          style={{
                                                            padding:
                                                              "7px",
                                                            color:
                                                              "#fff",
                                                            background:
                                                              plan.colorPrimary !==
                                                                null
                                                                ? plan.colorPrimary
                                                                : planTitleColors[
                                                                index %
                                                                planTitleColors.length
                                                                ],
                                                          }}
                                                        >
                                                          {plan.name}
                                                        </h3>
                                                        <div
                                                          class="price "
                                                          style={{
                                                            background:
                                                              plan.colorPrimary !==
                                                                null
                                                                ? plan.colorPrimary
                                                                : planTitleColors[
                                                                index %
                                                                planTitleColors.length
                                                                ],
                                                          }}
                                                        >
                                                          <span
                                                          // style={{
                                                          //   left: "10px",
                                                          // }}
                                                          >
                                                            {`${plan?.currency !==
                                                              null
                                                              ? plan
                                                                ?.currency
                                                                .symbol
                                                              : ""
                                                              }${plan?.price
                                                              }`}
                                                          </span>
                                                        </div>
                                                      </div>
                                                      <div className="entry-content flex-grow-1 d-flex flex-column">
                                                        <ul className="flex-grow-1">
                                                          {plan?.planItems.map(
                                                            (
                                                              planItems,
                                                              index
                                                            ) => (
                                                              <li
                                                                style={{
                                                                  padding:
                                                                    "0.2em",
                                                                  fontWeight:
                                                                    planItems?.isFontBold &&
                                                                    "600",
                                                                  fontStyle:
                                                                    planItems?.isFontItalic &&
                                                                    "italic",
                                                                }}
                                                              >
                                                                {
                                                                  planItems.name
                                                                }
                                                              </li>
                                                            )
                                                          )}
                                                        </ul>
                                                        <div className="row p-3">
                                                          <div className="buy_now_btn2 col-md-12 text-center mt-auto">
                                                            <div className="btn_plan1">
                                                              <a
                                                                style={{
                                                                  borderRadius:
                                                                    "10px",
                                                                  backgroundColor:
                                                                    plan.colorPrimary !==
                                                                      null
                                                                      ? plan.colorPrimary
                                                                      : planTitleColors[
                                                                      index %
                                                                      planTitleColors.length
                                                                      ],
                                                                }}
                                                                onClick={this.handleOnClickSelectedPlan.bind(
                                                                  this,
                                                                  plan
                                                                )}
                                                              >
                                                                Select
                                                              </a>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              ))}
                                            </div>
                                          </TabPanel>
                                        ))}

                                      </Tabs>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {this.state.activeCompanyDetailsStep === true && (
                          <ValidatorForm
                            ref="form"
                            id="multiStepsForm"
                            onSubmit={this.createAccountInBackend.bind(this)}
                          >
                            <div
                              id="personalInfoValidation"
                              className={
                                this.state.activeCompanyDetailsStep === true
                                  ? "content active dstepper-block fv-plugins-bootstrap5 fv-plugins-framework"
                                  : "content"
                              }
                            >
                              <div
                                className="card"
                                id="giveBeeCard"
                                style={{
                                  marginTop: "1em",
                                }}
                              >
                                <div className="row g-3">
                                  <h5 class="heading">
                                    <b>
                                      <>
                                        Enter Client's Contact Info{" "}
                                        <span
                                          style={{
                                            fontWeight: "normal",
                                            fontSize: "16px",
                                          }}
                                        >
                                          (the person who will manage DPTEXT
                                          campaigns){" "}
                                        </span>
                                      </>
                                    </b>
                                  </h5>
                                </div>
                                <div className="row g-3">
                                  <div className="col-sm-4">
                                    <label
                                      className="form-label"
                                      htmlFor="multiStepsFirstName"
                                    >
                                      Email ID
                                    </label>
                                    <input
                                      title=""
                                      required
                                      autoComplete="off"
                                      type="email"
                                      value={this.state.email}
                                      onChange={this.handleEmailChange.bind(
                                        this
                                      )}
                                      onBlur={this.searchExistingEmail.bind(this)}
                                      id="multiStepsFirstName"
                                      name="multiStepsFirstName"
                                      className="form-control"
                                      aria-label="john.doe"
                                    />
                                  </div>
                                  <div className="col-sm-4">
                                    <label
                                      className="form-label"
                                      htmlFor="multiStepsFirstName"
                                    >
                                      First Name
                                    </label>
                                    <input
                                      title=""
                                      required
                                      autoComplete="off"
                                      type="text"
                                      id="multiStepsFirstName"
                                      name="multiStepsFirstName"
                                      className="form-control"
                                      value={this.state.firstName}
                                      onChange={this.handleFnameChange.bind(
                                        this
                                      )}
                                    />
                                  </div>
                                  <div className="col-sm-4">
                                    <label
                                      className="form-label"
                                      htmlFor="multiStepsLastName"
                                    >
                                      Last Name
                                    </label>
                                    <input
                                      required
                                      title=""
                                      autoComplete="off"
                                      type="text"
                                      value={this.state.lastName}
                                      onChange={this.handleLnameChange.bind(
                                        this
                                      )}
                                      id="multiStepsFirstName"
                                      name="multiStepsFirstName"
                                      className="form-control"
                                    />
                                  </div>
                                </div>
                                <div className="row g-3 mt-2">
                                  <div className="col-sm-4">
                                    <label
                                      className="form-label"
                                      htmlFor="multiStepsEmail"
                                    >
                                      Job Title
                                    </label>
                                    <input
                                      title=""
                                      required
                                      type="text"
                                      autoComplete="off"
                                      id="multiStepsFirstName"
                                      name="multiStepsFirstName"
                                      className="form-control"
                                      value={this.state.jobTitle}
                                      onChange={this.handleJobTitleChange.bind(
                                        this
                                      )}
                                    />
                                  </div>
                                  <div className="col-sm-4">
                                    <label
                                      className="form-label "
                                      htmlFor="collapsible-phone"
                                    >
                                      Mobile No - <b style={{ fontSize: "12px", color: "red" }}>IMPORTANT! MUST BE USER'S PRIMARY MOBILE</b>
                                    </label>
                                    {enableCountryCode ?
                                      <span className="d-flex">
                                        <PhoneInput
                                          country="us"
                                          onlyCountries={["us", "ca", "au", "in"]}
                                          value={this.state.countryCode}
                                          onChange={(
                                            phone,
                                            country,
                                            e,
                                            formattedValue
                                          ) => {
                                            this.handleCountryCodeChange(
                                              phone,
                                              country,
                                              e,
                                              formattedValue
                                            );
                                          }}
                                          autoFormat
                                          countryCodeEditable={false}
                                          disableCountryGuess={false}
                                          enableSearch={true}
                                          alwaysDefaultMask={true}
                                        />
                                        <input
                                          title=""
                                          required
                                          type="text"
                                          autoComplete="off"
                                          name="multiStepsFirstName"
                                          style={{
                                            borderRadius: "0px 5px 5px 0px",
                                          }}
                                          className="form-control"
                                          value={this.state.phone}
                                          onChange={this.handlePhoneChange.bind(
                                            this
                                          )}
                                          validators={["required"]}
                                          errormessages={[
                                            "This field is required",
                                          ]}
                                          onInvalid={(e) => {
                                            e.target.setCustomValidity(
                                              "Mobile number required"
                                            );
                                          }}
                                        />
                                      </span>
                                      :
                                      <input
                                        title=""
                                        required
                                        type="text"
                                        autoComplete="off"
                                        name="multiStepsFirstName"
                                        className="form-control"
                                        value={this.state.phone}
                                        onChange={this.handlePhoneChange.bind(
                                          this
                                        )}
                                        validators={["required"]}
                                        errormessages={[
                                          "This field is required",
                                        ]}
                                        onInvalid={(e) => {
                                          e.target.setCustomValidity(
                                            "Mobile number required"
                                          );
                                        }}
                                      />
                                    }
                                  </div>
                                  <div className="col-sm-4">
                                    <label
                                      className="form-label "
                                      htmlFor="collapsible-officephone"
                                    >
                                      Office Phone No
                                    </label>
                                    {enableCountryCode ?
                                      <span className="d-flex">
                                        <PhoneInput
                                          country="us"
                                          onlyCountries={["us", "ca", "au", "in"]}
                                          value={this.state.officeCountryCode}
                                          onChange={(
                                            phone,
                                            country,
                                            e,
                                            formattedValue
                                          ) => {
                                            this.handleOfficeCountryChange(
                                              phone,
                                              country,
                                              e,
                                              formattedValue
                                            );
                                          }}
                                          autoFormat
                                          countryCodeEditable={false}
                                          disableCountryGuess={false}
                                          enableSearch={true}
                                          alwaysDefaultMask={true}
                                        />
                                        <input
                                          title=""
                                          required
                                          type="text"
                                          autoComplete="off"
                                          id="multiStepsFirstName"
                                          name="multiStepsFirstName"
                                          style={{
                                            borderRadius: "0px 5px 5px 0px",
                                          }}
                                          className="form-control"
                                          value={this.state.officePhone}
                                          onChange={this.handleOfficePhoneChange.bind(
                                            this
                                          )}
                                          validators={["required"]}
                                          errormessages={[
                                            "This field is required",
                                          ]}
                                          onInvalid={(e) => {
                                            e.target.setCustomValidity(
                                              "Mobile number required"
                                            );
                                          }}
                                        />
                                      </span>
                                      : <input
                                        title=""
                                        required
                                        type="text"
                                        autoComplete="off"
                                        id="multiStepsFirstName"
                                        name="multiStepsFirstName"
                                        className="form-control"
                                        value={this.state.officePhone}
                                        onChange={this.handleOfficePhoneChange.bind(
                                          this
                                        )}
                                        validators={["required"]}
                                        errormessages={[
                                          "This field is required",
                                        ]}
                                        onInvalid={(e) => {
                                          e.target.setCustomValidity(
                                            "Mobile number required"
                                          );
                                        }}
                                      />
                                    }
                                  </div>
                                </div>
                                <hr />
                                <div className="row g-3">
                                  <div className="col-md-6 pe-3" style={{ borderRight: "2px solid #d3d3d3" }}>
                                    <div
                                      className="content-header"
                                      style={{
                                        display: "flex",
                                        padding: "0.5em 0em",
                                      }}
                                    >
                                      <h5 className="heading">
                                        <b>
                                          Enter Client's Company/Organization
                                          Information
                                        </b>
                                      </h5>
                                    </div>
                                    <div className="row g-3">
                                      <div className="col-sm-6">
                                        <label
                                          className="form-label"
                                          htmlFor="multiStepsFirstName"
                                        >
                                          {Utils.equalsIgnoreCase(this.state.country?.name, "Canada") ? "Bus. Reg. # (BN)" : "Bus. Reg. # (EIN)"}
                                        </label>
                                        <input
                                          autoComplete="off"
                                          required
                                          title=""
                                          type="text"
                                          placeholder={Utils.equalsIgnoreCase(this.state.country?.name, "Canada") ? "12345 6789" : "12-123456"}
                                          id="multiStepsFirstName"
                                          name="multiStepsFirstName"
                                          className="form-control"
                                          value={this.state.eIn}
                                          onChange={this.handleEinChange.bind(
                                            this
                                          )}
                                        />
                                        {this.state.einErrorMessageText && (
                                          <p
                                            style={{
                                              color: "red",
                                              fontSize: "13px",
                                            }}
                                          >
                                            {this.state.einErrorMessageText}
                                          </p>
                                        )}
                                      </div>
                                      <div className="col-sm-6">
                                        <label
                                          className="form-label"
                                          htmlFor="multiStepsEmail"
                                        >
                                          Business Name
                                          <InfoTooltip
                                            data="Please enter the exact legal business
                                      name, as registered with the EIN. E.g. ABC
                                      Company Inc. rather than ABC Company."
                                            style={{
                                              float: "right",
                                            }}
                                          />
                                        </label>
                                        <input
                                          title=""
                                          required
                                          autoComplete="off"
                                          type="text"
                                          value={this.state.businessName}
                                          onChange={this.handleBusinessNameChange.bind(
                                            this
                                          )}
                                          id="multiStepsFirstName"
                                          name="multiStepsFirstName"
                                          className="form-control"
                                          aria-label="john.doe"
                                        />
                                      </div>
                                    </div>
                                    <div
                                      className="row g-3"
                                      style={{ marginTop: "0.5em" }}
                                    >
                                      <div className="col-sm-12">
                                        <label
                                          className="form-label"
                                          htmlFor="multiStepsEmail"
                                        >
                                          Company Website URL
                                        </label>
                                        <input
                                          title=""
                                          required
                                          autoComplete="off"
                                          type="text"
                                          id="multiStepsName"
                                          className="form-control"
                                          name="multiStepsName"
                                          value={this.state.companyWebsite}
                                          onChange={this.handleCompanyWebsiteChange.bind(
                                            this
                                          )}
                                        />
                                        {this.state.cwUrlErrorMessage && (
                                          <p
                                            className="mb-0"
                                            style={{
                                              color: "red",
                                              fontSize: "13px",
                                            }}
                                          >
                                            {this.state.cwUrlErrorMessage}
                                          </p>
                                        )}
                                      </div>
                                    </div>
                                    <div
                                      className="row g-3"
                                      style={{ marginTop: "0.5em" }}
                                    >
                                      <div className="col-sm-12">
                                        <label
                                          className="form-label"
                                          htmlFor="multiStepsEmail"
                                        >
                                          Business T&Cs URL
                                          <InfoTooltip
                                            data="Web address that contains your SMS Terms &
                                      Conditions"
                                            style={{
                                              float: "right",
                                            }}
                                          />
                                        </label>
                                        <input
                                          title=""
                                          required
                                          autoComplete="off"
                                          type="text"
                                          value={this.state.smsTAndCUrl}
                                          onChange={this.handleSmsTAndCUrlChange.bind(
                                            this
                                          )}
                                          id="multiStepsFirstName"
                                          name="multiStepsFirstName"
                                          className="form-control"
                                          aria-label="john.doe"
                                        />
                                        {this.state.errorMessageText && (
                                          <p
                                            style={{
                                              color: "red",
                                              fontSize: "13px",
                                            }}
                                          >
                                            {this.state.errorMessageText}
                                          </p>
                                        )}
                                      </div>
                                    </div>
                                    <div
                                      className="row g-3"
                                      style={{ marginTop: "0.5em" }}
                                    >
                                      <div className="col-sm-12">
                                        <label
                                          className="form-label"
                                          htmlFor="multiStepsEmail"
                                        >
                                          Business Privacy Policy URL
                                        </label>
                                        <input
                                          title=""
                                          required
                                          autoComplete="off"
                                          type="text"
                                          value={this.state.smsPrivacyPolicyUrl}
                                          onChange={this.handleSmsPrivacyPolicyUrlChange.bind(
                                            this
                                          )}
                                          id="multiStepsFirstName"
                                          name="multiStepsFirstName"
                                          className="form-control"
                                          aria-label="john.doe"
                                        />
                                        {this.state.privacyErrorMessageText && (
                                          <p
                                            style={{
                                              color: "red",
                                              fontSize: "13px",
                                            }}
                                          >
                                            {this.state.privacyErrorMessageText}
                                          </p>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-6 ps-3">
                                    <div
                                      className="content-header"
                                      style={{
                                        display: "flex",
                                        padding: "0.5em 0em",
                                      }}
                                    >
                                      <h5 className="heading">
                                        <b>
                                          Enter Client's Company/Organization
                                          Address
                                        </b>
                                      </h5>
                                    </div>
                                    <div className="row g-3">
                                      <div class="col-sm-12">
                                        <label
                                          class="form-label"
                                          htmlFor="multiStepsEmail"
                                        >
                                          Street Address
                                        </label>
                                        <input
                                          title=""
                                          required
                                          autoComplete="off"
                                          type="text"
                                          id="multiStepsFirstName"
                                          name="multiStepsFirstName"
                                          className="form-control"
                                          onChange={this.handleLine1Change.bind(
                                            this
                                          )}
                                          value={this.state.line}
                                        />
                                      </div>
                                    </div>
                                    <div
                                      className="row g-3"
                                      style={{ marginTop: "0.5em" }}
                                    >
                                      <div className="col-md-6">
                                        <label
                                          className="form-label"
                                          htmlFor="collapsible-fullname"
                                        >
                                          City
                                        </label>
                                        <input
                                          title=""
                                          required
                                          autoComplete="off"
                                          type="text"
                                          id="multiStepsFirstName"
                                          name="multiStepsFirstName"
                                          className="form-control"
                                          value={this.state.city}
                                          onChange={this.handleCityChange.bind(
                                            this
                                          )}
                                        />
                                      </div>
                                      <div class="col-sm-6">
                                        <label
                                          className="form-label"
                                          htmlFor="multiStepsState"
                                        >
                                          State/Province/Region
                                        </label>

                                        <Autocomplete
                                          id="size-small-outlined"
                                          size="small"
                                          fullWidth
                                          disableClearable
                                          autoComplete="off"
                                          ListboxProps={{
                                            className: "custom-listbox",
                                          }}
                                          options={this.stateListArray}
                                          value={this.state.state}
                                          getOptionLabel={(option) =>
                                            option.namecode
                                          }
                                          defaultValue={this.state.state}
                                          onChange={(event, value) => {
                                            this.handleStateChange(value);
                                          }}
                                          inputprops={{
                                            style: {
                                              textTransform: "capitalize",
                                            },
                                          }}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              placeholder="Please Select"
                                              variant="outlined"
                                              size="small"
                                              className="textField"
                                              required
                                              title=""
                                              style={{ background: "#fff" }}
                                            />
                                          )}
                                        />
                                      </div>
                                    </div>
                                    <div
                                      className="row g-3"
                                      style={{ marginTop: "0.5em" }}
                                    >
                                      <div className="col-md-6">
                                        <label
                                          className="form-label"
                                          htmlFor="collapsible-fullname"
                                        >
                                          Zip/Postal Code
                                        </label>
                                        <input
                                          title=""
                                          type="text"
                                          required
                                          autoComplete="off"
                                          id="multiStepsLastName"
                                          class="form-control"
                                          value={this.state.zipcode}
                                          onChange={this.handlePinCodeChange.bind(
                                            this
                                          )}
                                          inputprops={{ maxLength: 16 }}
                                          name="zipcode"
                                        />
                                        {this.state.zipCodeErrorMessageText && (
                                          <p
                                            style={{
                                              color: "red",
                                              fontSize: "13px",
                                            }}
                                          >
                                            {this.state.zipCodeErrorMessageText}
                                          </p>
                                        )}
                                      </div>
                                      <div class="col-sm-6">
                                        <label
                                          class="form-label"
                                          htmlFor="multiStepsEmail"
                                        >
                                          Country
                                        </label>

                                        <Autocomplete
                                          id="size-small-outlined"
                                          size="small"
                                          fullWidth
                                          disableClearable
                                          autoComplete="off"
                                          ListboxProps={{
                                            className: "custom-listbox",
                                          }}
                                          options={this.countryListArray}
                                          value={this.state.country}
                                          defaultValue={this.state.select}
                                          getOptionLabel={(option) =>
                                            option.namecode
                                          }
                                          onChange={(event, value) => {
                                            this.handleCountryChange(value);
                                          }}
                                          inputprops={{
                                            style: {
                                              textTransform: "capitalize",
                                            },
                                          }}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              placeholder="Please Select"
                                              variant="outlined"
                                              required
                                              title=""
                                              style={{ background: "#fff" }}
                                            />
                                          )}
                                        />
                                      </div>
                                      <div
                                        className="row g-3"
                                        style={{ marginTop: "0.5em" }}
                                      >
                                        <div className="col-md-7">
                                          <label
                                            class="form-label"
                                            htmlFor="multiStepsEmail"
                                          >
                                            Timezone
                                          </label>
                                          <Autocomplete
                                            id="size-small-outlined"
                                            size="small"
                                            fullWidth
                                            disableClearable
                                            ListboxProps={{
                                              className: "custom-listbox",
                                            }}
                                            options={this.timeZoneListArray}
                                            value={this.state.timeZone}
                                            getOptionLabel={(option) => option.displayText}
                                            defaultValue={this.state.timeZone}
                                            onChange={(event, value) => {
                                              this.handleTimeZoneChange(value);
                                            }}
                                            inputprops={{
                                              style: {
                                                textTransform: "capitalize",
                                              },
                                            }}
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                placeholder="Please Select"
                                                variant="outlined"
                                                size="small"
                                                className="textField"
                                                required
                                                title=""
                                                style={{ background: "#fff" }}
                                              />
                                            )}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {this.state.selectedPlan?.planType?.type === "Onetime" &&
                                  <>
                                    < hr />
                                    <div className="row g-3">
                                      <h5 class="heading">
                                        <b>
                                          Event Details
                                        </b>
                                      </h5>
                                    </div>
                                    <div className="row g-3 mb-2">
                                      <div className="col-md-3" id="assetFormLabel">
                                        <label
                                          className="form-label MuiAutocomplete-label"
                                          htmlFor="collapsible-email"
                                        >
                                          Start Date*
                                          <span
                                            className="ms-1"
                                            style={{
                                              fontSize: "12px",
                                              fontWeight: "400",
                                            }}
                                          >
                                            (Texting First Day)
                                          </span>
                                        </label>

                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                          <ThemeProvider theme={materialTheme}>
                                            <DatePicker
                                              value={this.state.startDate}
                                              variant="outlined"
                                              fullWidth
                                              size="small"
                                              inputVariant="outlined"
                                              // timeinputlabel="Time:"
                                              minDate={subDays(new Date(), 0)}
                                              format="MM/dd/yyyy"
                                              style={{ background: "#fff" }}
                                              onChange={this.handleStartDateChange.bind(
                                                this
                                              )}
                                              helperText={
                                                this.state.errorMassage
                                                  ? "Start Date is Required"
                                                  : ""
                                              }
                                              error={this.state.errorMassage}
                                              InputProps={{
                                                readOnly: true,
                                                endAdornment: (
                                                  <InputAdornment position="end">
                                                    <IconButton>
                                                      <span className="picker-icon" style={{ fontSize: "22px" }}>📅</span>
                                                    </IconButton>
                                                  </InputAdornment>
                                                ),
                                              }}
                                            />
                                          </ThemeProvider>
                                        </MuiPickersUtilsProvider>
                                      </div>
                                      <div className="col-md-3" id="assetFormLabel">
                                        <label
                                          className="form-label MuiAutocomplete-label"
                                          htmlFor="collapsible-jotitle"
                                        >
                                          End Date*
                                          <span
                                            className="ms-1"
                                            style={{
                                              fontSize: "12px",
                                              fontWeight: "400",
                                            }}
                                          >
                                            (Texting Last Day)
                                          </span>
                                        </label>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                          <ThemeProvider theme={materialTheme}>
                                            <DatePicker
                                              value={this.state.endDate}
                                              variant="outlined"
                                              fullWidth
                                              size="small"
                                              inputVariant="outlined"
                                              minDate={subDays(new Date(), 0)}
                                              format="MM/dd/yyyy"
                                              style={{ background: "#fff" }}
                                              onChange={this.handleEndDateChange.bind(
                                                this
                                              )}
                                              helperText={
                                                this.state.endDateErrorMassage
                                                  ? "End Date is Required"
                                                  : ""
                                              }
                                              error={this.state.endDateErrorMassage}
                                              InputProps={{
                                                readOnly: true,
                                                endAdornment: (
                                                  <InputAdornment position="end">
                                                    <IconButton>
                                                      <span className="picker-icon" style={{ fontSize: "22px" }}>📅</span>
                                                    </IconButton>
                                                  </InputAdornment>
                                                ),
                                              }}
                                            />
                                          </ThemeProvider>
                                        </MuiPickersUtilsProvider>
                                        {this.state.error ? (
                                          <lable className="errorMassageShow">
                                            End Date should be after Start Date
                                          </lable>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </div>
                                  </>
                                }
                                <hr />
                                <div className="row g-3">
                                  <h5 class="heading">
                                    <b>
                                      Enter DonorPerfect Customer Account
                                      Details
                                    </b>
                                  </h5>
                                </div>
                                <div className="row g-3 mb-2">
                                  <div className="col-sm-4">
                                    <label
                                      className="form-label"
                                      htmlFor="multiStepsFirstName"
                                    >
                                      DonorPerfect API key
                                    </label>
                                    <input
                                      title=""
                                      autoComplete="off"
                                      required
                                      type="text"
                                      id="multiStepsFirstName"
                                      name="multiStepsFirstName"
                                      className="form-control"
                                      value={this.state.donerPerfectApiKey}
                                      onChange={this.handleDonerPerfectApiKeyChange.bind(
                                        this
                                      )}
                                    />
                                  </div>
                                  <div className="col-sm-4">
                                    <label
                                      className="form-label"
                                      htmlFor="multiStepsFirstName"
                                    >
                                      DonorPerfect Client ID
                                    </label>
                                    <input
                                      title=""
                                      autoComplete="off"
                                      required
                                      type="text"
                                      id="multiStepsFirstName"
                                      name="multiStepsFirstName"
                                      className="form-control"
                                      value={this.state.donerPerfectCliendId}
                                      onChange={this.handleDonerPerfectCliendIDChange.bind(
                                        this
                                      )}
                                    />
                                  </div>
                                </div>
                                <hr />
                                <div className="row g-3 mb-4">
                                  <div className="col-sm-4">
                                    <label
                                      className="form-label"
                                      htmlFor="multiStepsFirstName"
                                    >
                                      DP Sales Person Name
                                    </label>
                                    <input
                                      title=""
                                      autoComplete="off"
                                      required
                                      type="text"
                                      id="multiStepsFirstName"
                                      name="multiStepsFirstName"
                                      className="form-control"
                                      value={this.state.dpSalesPerson}
                                      onChange={this.handleDPSalesPersonChange.bind(
                                        this
                                      )}
                                    />
                                  </div>
                                  <div className="col-sm-4">
                                    <label
                                      className="form-label"
                                      htmlFor="multiStepsFirstName"
                                    >
                                      DP Sales Person Email
                                    </label>
                                    <input
                                      title=""
                                      autoComplete="off"
                                      required
                                      type="email"
                                      id="multiStepsFirstName"
                                      name="multiStepsFirstName"
                                      className="form-control"
                                      value={this.state.dpSalesPersonEmail}
                                      onChange={this.handleDPSalesPersonEmailChange.bind(
                                        this
                                      )}
                                    />
                                  </div>
                                </div>
                                {/* </div> */}
                              </div>
                              <div
                                className="col-12 d-flex justify-content-between"
                                style={{ marginTop: "2em" }}
                              >
                                <button
                                  className="btn btn-label-secondary btn-prev"
                                  style={{
                                    display: "flex",
                                    background: "gray",
                                    color: "#fff",
                                  }}
                                  onClick={this.handlePreviousPlanDetailsPage.bind(
                                    this
                                  )}
                                >
                                  <i className="bx bx-chevron-left bx-sm ms-sm-n2"></i>
                                  <span className="align-middle d-sm-inline-block d-none">
                                    Back
                                  </span>
                                </button>
                                <button
                                  type="submit"
                                  style={{ background: "#37517e" }}
                                  className="btn btn-success btn-next btn-submit"
                                >
                                  Submit
                                </button>
                              </div>{" "}
                            </div>
                          </ValidatorForm>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div >
      </>
    );
  }
}

export default withRouter(DPTextRegistration);
